<template>
  <v-app>
    <NuxtLayout/>
  </v-app>
</template>

<style>
body, div.v-application {
  background: url('./background.jpg') repeat;
  background-size: 40%;
}
.v-btn {
  text-transform: none;
}
</style>

